import { render } from "./SkeletonPendingActionsSlider.vue?vue&type=template&id=726264b0"
import script from "./SkeletonPendingActionsSlider.vue?vue&type=script&lang=js"
export * from "./SkeletonPendingActionsSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__